<script setup>
import {computed} from "vue";
import AllPersonsStrip from "./AllPersonsStrip.vue";
import {mdiMagnify} from "@mdi/js";
import {gettext} from "../../../../utils/translate";


const props = defineProps({
    hpo: {
        type: Object,
        required: true
    },
    member: {
        type: Object,
        required: true
    },
    countries: {
        type: Array,
        required: true
    },
    anyLoading: {
        type: Boolean,
        required: true
    },
    patientList: {
        type: Array,
        required: true
    },
    readOnly: {
        type: Boolean,
        default: false
    },
})

const emit = defineEmits(['displayActionsModal'])


const countryChoices = computed(() => {
    return props.countries.reduce((obj, item) => Object.assign(obj, {[item.code]: item.name}), {});
})


function getCountryName(countryCode) {
    if (countryCode) {
        return countryChoices.value[countryCode]
    }
    return '–'
}

function handleDisplayActionsModal(patient) {
    emit('displayActionsModal', patient)
}

</script>

<template>
    <v-empty-state v-if="patientList.length === 0"
                 :icon="mdiMagnify"
                 :title="gettext('No patients found')">
  </v-empty-state>

    <AllPersonsStrip v-for="patient in patientList"
                     :key="patient.id"
                     :patient="patient"
                     :member="member"
                     :readOnly="readOnly"
                     :countryName="getCountryName(patient.country)"
                     @displayActionsModal="handleDisplayActionsModal"/>


</template>